import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { useTheme } from '../../context/ThemeContext';
import { Avatar, AvatarFallback } from '../ui/avatar';
import {
  DropdownMenu, DropdownMenuContent, DropdownMenuItem,
  DropdownMenuSeparator, DropdownMenuTrigger,
} from '../ui/dropdown-menu';
import { Settings, LogOut, Sun, Moon, ChevronDown } from 'lucide-react';

const ROLE_LABELS = {
  superadmin: 'Super Admin',
  admin: 'Amministratore',
  manager: 'Manager',
  staff: 'Dipendente',
};

/** Avatar con menu account, usato nella barra in alto e in quella mobile. */
export const UserMenu = ({ showName = false, testId = 'user-menu-trigger' }) => {
  const { user, logout } = useAuth();
  const { theme, toggleTheme } = useTheme();
  const navigate = useNavigate();

  const initials = user?.name?.split(' ').map((n) => n[0]).join('').toUpperCase() || 'U';

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button
          className="flex items-center gap-2 rounded-full pl-1 pr-1 sm:pr-2 py-1 hover:bg-muted transition-colors"
          data-testid={testId}
        >
          <Avatar className="w-8 h-8">
            <AvatarFallback className="bg-primary/10 text-primary text-sm">{initials}</AvatarFallback>
          </Avatar>
          {showName && (
            <>
              <span className="text-sm font-medium max-w-[160px] truncate" data-testid="user-menu-name">
                {user?.name}
              </span>
              <ChevronDown className="w-4 h-4 text-muted-foreground" />
            </>
          )}
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-56">
        <div className="px-2 py-1.5">
          <p className="text-sm font-medium truncate">{user?.name}</p>
          <p className="text-xs text-muted-foreground truncate">{user?.email}</p>
          <p className="text-xs text-muted-foreground">{ROLE_LABELS[user?.role] || user?.role}</p>
        </div>
        <DropdownMenuSeparator />
        <DropdownMenuItem onClick={toggleTheme} data-testid="menu-toggle-theme">
          {theme === 'dark' ? <Sun className="w-4 h-4 mr-2" /> : <Moon className="w-4 h-4 mr-2" />}
          {theme === 'dark' ? 'Modalità Chiara' : 'Modalità Scura'}
        </DropdownMenuItem>
        <DropdownMenuItem onClick={() => navigate('/settings')} data-testid="menu-settings">
          <Settings className="w-4 h-4 mr-2" />Impostazioni
        </DropdownMenuItem>
        <DropdownMenuSeparator />
        <DropdownMenuItem
          onClick={() => { logout(); navigate('/login'); }}
          className="text-destructive focus:text-destructive"
          data-testid="menu-logout"
        >
          <LogOut className="w-4 h-4 mr-2" />Esci
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default UserMenu;
